<template>
    <v-flex xs12>
        <h2>Reprocesos de ventas</h2>
        <v-layout row wrap>
            <v-flex sx4>
                <empresa-select v-model="d.empresa" multiple></empresa-select>
            </v-flex>
            <v-flex>
                <v-menu
                        lazy
                        :close-on-content-click="false"
                        v-model="menuDesde"
                        :return-value.sync="menuDesde"
                        ref="menuDesde"
                >
                    <v-text-field
                            name="desde"
                            slot="activator"
                            label="Desde"
                            v-model="d.desde"
                            prepend-icon="event"
                            readonly></v-text-field>
                    <v-date-picker
                            v-model="d.desde"
                            first-day-of-week="1"
                            locale="es-sp"
                            scrollable
                            @input="$refs.menuDesde.save(date)"
                    ></v-date-picker>
                </v-menu>
                <v-menu
                        lazy
                        :close-on-content-click="false"
                        v-model="menuHasta"
                        transition="v-scale-transition"
                >
                    <v-text-field
                            name="desde"
                            slot="activator"
                            label="Hasta"
                            v-model="d.hasta"
                            prepend-icon="event"
                            readonly
                            ref="menuHasta"
                    ></v-text-field>
                    <v-date-picker
                            v-model="d.hasta"
                            first-day-of-week="1"
                            locale="es-sp"
                            scrollable
                            @input="$refs.menuHasta.save(date)"
                    ></v-date-picker>
                </v-menu>
            </v-flex>


            <v-btn dark default @click.native="mostrar()" :loading="loading">MOSTRAR</v-btn>
        </v-layout>
        <v-progress-linear :indeterminate="true" :query="true" :active="loading" height="5"></v-progress-linear>
        <div ref="chart" style="width: 100%"></div>
    </v-flex>
</template>
<script>
    import Highcharts from 'highcharts';
    import empresaSelect from '../../components/EmpresaSelect.vue'

    export default {
        components: {empresaSelect},
        data() {
            return {
                loading: false,
                menuDesde: false,
                menuHasta: false,
                empresas: [],
                monedas: [],
                d: {
                    empresa: [],
                    tipo: '',
                    desde: moment().subtract(1, 'year').format('YYYY-MM-DD'),
                    hasta: moment().format('YYYY-MM-DD')
                },
                datos: {},
                t: {},
                tipos: [
                    {id: 'real', desig: 'Fecha de Entrega Real'},
                    {id: 'prevista', desig: 'Fecha de Entrega Prevista'},
                ]
            }
        },
        methods: {
            mostrar() {
                this.loading = true;
                this.$http.post('indicadores/rep-ventas', this.d)
                    .then(r => {
                        if (r.type === 'error') {
                            this.loading = false;
                            return false
                        }
                        this.datos = r.data.datos;
                        this.t = r.data.totales;
                        this.cargaChart();
                        this.loading = false;
                    }, r => {
                        err(r)
                    });
            },
            cargaChart() {
                let self = this;
                Highcharts.chart(this.$refs.chart, {
//                    colors: ['#3b9d3b', '#D62C1A', '#ffdd32'],
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'column',
                        zoomType: 'x'
                    },
                    plotOptions: {
                        column: {
                            stacking: true,
                            dataLabels: {
                                enabled: true,
                                format: '{y}'
                            }
                        },
                        series: {
                            allowPointSelect: true,
                            states: {
                                select: {
                                    fillColor: 'red',
                                    lineWidth: 0
                                }
                            }
                        }
                    },
                    title: {
                        text: 'REPROCESOS DE VENTAS'
                    },
                    legend: {
                        labelFormat: '{name}'
                    },
                    tooltip: {
                        pointFormat: '{series.name} | {point.compl}: Monto: <b>{point.y:,.1f}</b>'
                    },
                    xAxis: {
                        type: 'category',
                        title: {
                            text: 'Provincias'
                        }
                    },
                    yAxis: {
                        title: {
                            text: 'Cantidad de operaciones'
                        },
                        stackLabels: {
                            enabled: true,
                            style: {
                                fontWeight: 'bold',
                                color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
                            },
                            format: '$ {total:,.2f}'
                        }
                    },
                    series: self.datos
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/rep-ventas.vue